/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */

import { csoCustomerOrder } from '@/api/ajax';
// 用于展示 供应商 费率列表
import rateList from '../components/rateList.vue';
import { moneyFixed, twoDecimal } from '@/tools/money.js';
import dateFormat from '@/tools/dateFormat';
import { payStatusRender } from '@/page/settlementCenter/utils';
import { taxCollectionPatternMap } from '@/config/staticData';
import { bankRowLabelFiled, payTypeRowLabelFiled } from '@/common/fields/bank'; // 在这混入兼容方便兼容之前数据

export default {
  selection: {
    type: 'selection',
    width: '100px',
    prop: 'orderNumber'
  },
  index: {
    width: '60px',
    label: '序号',
    type: 'index'
  },

  // 服务费支付状态
  serviceStatus: {
    label: '平台服务费状态',
    prop: 'serviceStatus',
    width: '100px',
    render(h, ctx, r, c) {
      const vm = ctx.parent;
      const jump = () => {
        vm.$router.push({
          name: 'orderMgmt|list',
          query: {
            orderNo: r.serviceOrderNo,
            // projectName: r.projectName,
            // taskDt: r.taskDt,
            part: r.serviceStatus === 2 ? 1 : 0
          }
        });
      };
      return (
        <el-button type="text" onClick={jump}>
          {['未支付', '支付中', '支付成功', '支付失败'][r[c.property] || 0]}
        </el-button>
      );
    }
  },

  // 服务费支付状态
  bussniessServicesStatus: {
    label: '商务服务费状态',
    prop: 'bussniessServicesStatus',
    width: '100px',
    render(h, ctx, r, c) {
      const vm = ctx.parent;
      const jump = () => {
        vm.$router.push({
          name: 'orderMgmt|list',
          query: {
            orderNo: r.bussniessServicesOrderNo,
            // projectName: r.projectName,
            // taskDt: r.taskDt,
            part: r.serviceStatus === 2 ? 1 : 0
          }
        });
      };
      if (r[c.property] === null) {
        return <span>-</span>;
      }
      return (
        <el-button type="text" onClick={jump}>
          {['未支付', '支付中', '支付成功', '支付失败'][r[c.property] || 0]}
        </el-button>
      );
    }
  },
  orderNumber: {
    label: '订单编号',
    prop: 'orderNumber'
  },
  orderCreateDt: {
    label: '订单生成时间',
    prop: 'orderCreateDt'
  },
  // 需要列表的structureType区分支付类型与当前row的orderNo
  // ！！无区分structureType
  orderNo: {
    label: '订单编号',
    prop: 'orderNo',
    render(h, ctx, row) {
      const vm = ctx.parent;
      const payStatus = row.payStatus;
      const map = {
        0: [0, 1, 2],
        1: [3],
        2: [4]
      };
      let part = 0;
      Object.entries(map).forEach(([key, value]) => {
        if (~value.indexOf(payStatus)) {
          part = key;
        }
      });
      // orderStatus 优先级高
      part = row.orderStatus === 2 ? 2 : part;
      const jump = () => {
        vm.$router.push({
          name: 'orderMgmt|list',
          query: {
            orderNo: row.orderNo,
            part
          }
        });
        vm.$xrkDialog.clear();
      };
      return (
        <el-button type="text" onClick={jump}>
          {row.orderNo}
        </el-button>
      );
    }
  },
  createDt: {
    label: '结算时间',
    prop: 'createDt',
    formatter(r, c, v) {
      return dateFormat(v) || '-';
    }
  },
  paymentDeadline: {
    label: '支付截止时间',
    prop: 'paymentDeadline',
    width: '200px'
  },
  orderPrice: {
    label: '本次需打款总金额',
    prop: 'orderPrice',
    width: '200px',
    render: function(h, ctx, r, c) {
      const showDialog = () => {
        ctx.parent.$xrkDialog({
          title: '本次需打款总金额',
          width: '90vw',
          // top:'5vh',
          $slots: {
            default: h('div', '本次需打款总金额')
          }
        });
      };
      return (
        <div class="orderPrice">
          <el-link icon="" type="primary" onClick={showDialog}>
            {r[c.property]}
          </el-link>
          <el-popover
            trigger="hover"
            placement="right"
            style={{ width: '200px', height: '50px' }}
          >
            <div style={{ width: '200px', height: '50px' }}>
              <div>应付：{r.yingfu}</div>
              <div>优惠：{r.youhui}</div>
              <div>实付：{r.shifu}</div>
            </div>
            <img
              slot="reference"
              src="http://cdn.yxvzb.com/WEB/SaaS/images/coupon.svg"
              style={{ width: '50px', height: '15px' }}
            />
          </el-popover>
        </div>
      );
    }
  },
  zhifuzhuangtai: {
    label: '支付状态',
    prop: 'payStatus',
    render: function(h, ctx, r, c) {
      const getPayStatus = () => {
        if (+r.payStatus === 3 && +r.isPeopleClose === 1) {
          return '已完结';
        } else {
          if (r.isPayFinish) {
            // 字段特殊处理，为了和OSS统一
            return ['', '已完成', '未完成'][r.isPayFinish || 0];
          } else {
            return ['未完成', '已完成'][r[c.property] || 0];
          }
        }
      };
      return (
        <div>
          <span>{getPayStatus()}</span>
          {!!+r.isPeopleClose && (
            <i
              class="el-icon-info"
              style="font-size: 17px; color: red; margin-left: 5px"
            ></i>
          )}
        </div>
      );
    }
  },
  operation: {
    label: '操作',
    render: function(h, ctx) {
      const showDialog = () => {
        let diglog = ctx.parent.$xrkDialog({
          title: '项目支付详情',
          width: '90vw',
          // top:'5vh',
          $slots: {
            // default: h(priceDetailUpdate),
            default: h('div', 'priceDetailUpdate'),
            footer: h(
              'div',
              {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '10px 50px'
                }
              },
              [
                h(
                  'el-button',
                  {
                    style: {
                      width: '150px'
                    },
                    props: { type: 'primary' },
                    on: {
                      click: () => {
                        csoCustomerOrder.delNoPayOrderPeople();
                        // diglog.remove();
                      }
                    }
                  },
                  '确认移除'
                ),
                h(
                  'el-button',
                  {
                    style: {
                      width: '150px'
                    },
                    props: {},
                    on: {
                      click: () => {
                        diglog.remove();
                      }
                    }
                  },
                  '关闭'
                )
              ]
            )
          }
        });
      };
      return (
        <div>
          {/*<el-button type="text" onClick={toPay}>支付</el-button>*/}

          <el-button type="text" onClick={showDialog}>
            修改支付人
          </el-button>
        </div>
      );
    }
  },

  yingfu: {
    label: '应付',
    prop: 'yingfu'
  },
  shifu: {
    label: '实付',
    prop: 'shifu'
  },
  youhui: {
    label: '优惠',
    prop: 'youhui'
  },

  dingdanbianhao: {
    label: '订单编号',
    prop: 'dingdanbianhao'
  },
  dingdanshengchengshijian: {
    label: '订单生成时间',
    prop: 'dingdanshengchengshijian'
  },
  zhifujiezhishijian: {
    label: '支付截止时间',
    prop: 'zhifujiezhishijian'
  },

  zhifujindu_unlink: {
    label: '支付进度',
    render: function(h, ctx, r) {
      // 已支付数量 / 总支付数量
      return <span>{`${r['payCount']}/${r['unPayCount']}`}</span>;
    }
  },

  payPrice: {
    label: '已支付项目金额',
    prop: 'payPrice',
    width: '120px',
    render: function(h, ctx, r, c) {
      return h('span', moneyFixed(r[c.property]));
    }
  },
  weizhifuxiangmujine: {
    label: '未支付项目金额',
    prop: 'payMoney',
    render: function(h, ctx, r) {
      return h('span', moneyFixed(r['unPayMoney'] - r['payMoney']));
    }
  },
  zhongduanjinejiesuanheji: {
    label: '终端结算金额合计',
    prop: 'terminalPrice',
    render: function(h, ctx, r, c) {
      return h('span', moneyFixed(r[c.property]));
    }
  },
  xiangmujiesuanzongjine: {
    label: '项目结算总金额',
    prop: 'unPayMoney',
    render: function(h, ctx, r, c) {
      return h('span', moneyFixed(r[c.property]));
    }
  },
  projectPrice: {
    label: '预计项目结算总金额',
    prop: 'projectPrice',
    width: '140px',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  // 结算订单 生成 -----------------------------------------------------------------------
  id: {
    type: 'selection',
    reserve: true,
    prop: 'id'
  },
  xiangmucanyuren: {
    label: '项目参与人',
    width: '120px',
    prop: 'userName'
  },
  shoujihao: {
    label: '手机号',
    prop: 'phone'
  },
  zhifujindu_shoujihao: {
    label: '手机号',
    prop: 'phone'
  },
  shoukuanzhanghao: {
    label: '收款账号',
    prop: 'bankNo'
  },
  shoukuanfangshi: {
    label: '收款方式', // 1 银行卡  2 钱包
    prop: 'collectMoneyType',
    render: function(h, ctx, r, c) {
      return h('div', [null, '银行卡', '钱包'][r[c.property]] || '-');
    }
  },
  xiangmumingcheng: {
    label: '项目名称',
    prop: 'projectName',
    width: 150
  },

  supplierName: {
    label: '供应商',
    prop: 'supplierName'
  },
  industryName: {
    label: '工业方',
    prop: 'industryName',
    width: 150,
    render(h, ctx, row) {
      return row.industryEnterpriseId == -1 ? (
        <span>-</span>
      ) : (
        <span>{row.industryEnterpriseName}</span>
      );
    }
  },
  supplierName_rateList: {
    label: '供应商',
    prop: 'supplierName',
    width: '200px',
    render: function(h, ctx, r) {
      return h(rateList, {
        props: {
          title: r.supplierName,
          list: r['rateList']
        }
      });
    }
  },
  shijiwanchengrenwuliang: {
    label: '实际完成任务量',
    prop: 'finishSum'
  },
  taskPrice: {
    label: '终端结算单价',
    prop: 'taskPrice',
    width: '120px',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  zhongduanjiesuanjine: {
    label: '终端结算金额',
    prop: 'terminalPrice',
    width: '120px',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  commission: {
    label: '服务费率',
    prop: 'commission',
    formatter(r, c, v) {
      if (!r.supplierName) {
        return '-';
      }
      return twoDecimal(v, 100, '%');
    }
  },
  serviceRate: {
    label: '服务费率',
    prop: 'serviceRate',
    formatter(r, c, v) {
      return v === '0' ? '-' : twoDecimal(v, 100, '%');
    }
  },
  unDecimalServiceRate: {
    label: '服务费率',
    prop: 'serviceRate',
    formatter(r, c, v) {
      return v === '0' ? '-' : (v || 0) + '%';
    }
  },
  settlementAmount: {
    label: '终端结算金额',
    prop: 'settlementAmount',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  totalAmount: {
    label: '结算总价',
    prop: 'totalAmount',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  xiangmuzhifujine: {
    label: '项目支付金额',
    prop: 'projectPayPrice',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  payStatus: {
    label: '支付状态',
    prop: 'payStatus',
    width: '120px',
    formatter(r) {
      return payStatusRender(r, 3);
    }
    // formatter(r, c, v) {
    // 	debugger
    // 	return ENUM.payStatus[r[c.property]]
    // }
  },
  zhongduanjiesuandanjia: {
    label: '终端结算单价',
    prop: 'taskPrice',
    width: '120px',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  totalPrice: {
    label: '结算总价',
    prop: 'totalPrice',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  jiesuanzongjia: {
    label: '结算总价',
    prop: 'totalPrice',
    formatter(r, c, v) {
      return moneyFixed(v);
    }
  },
  industryFenpeiCode: {
    label: '结算单号',
    prop: 'industryFenpeiCode',
    width: '140px'
  },
  finishPayDt: {
    label: '到账时间',
    prop: 'finishPayDt',
    formatter(r, c, v) {
      return dateFormat(v) || '-';
    }
  },
  finishGetPayDt: {
    label: '终端到账时间',
    prop: 'endPointFinishPayDt',
    formatter(r, c, v) {
      return v || '-';
    }
  },
  taxCollectionPattern: {
    label: '交易结构',
    prop: 'taxCollectionPattern',
    formatter(r, c, v) {
      return taxCollectionPatternMap[v] || '-';
    }
  },
  finishSum: {
    label: '预计可结算任务量',
    prop: 'finishSum'
  },
  jiesuanrenwuliang: {
    label: '结算任务量',
    prop: 'finishSum'
  },
  ...bankRowLabelFiled,
  ...payTypeRowLabelFiled
};
